import { OrderMatchFlterName } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/OrderMatchTab/OrderMatchesGrid/OrderMatchFilterUtils';
import {
  getDateRangeLabel,
  isDataIncluded,
  isIncluded,
  isItemIncluded,
  isSubstringIncluded,
  itemIsInRange,
  itemIsTillDate,
} from 'app/ComponentLibrary/Filter/helper';
import { ISelection } from 'app/ComponentLibrary/Filter/TypeAheadDropdown/CustomTypeAhead';
import { generateFieldChips } from 'app/components/AmWorkDesk/PlacementsDesk/filterHelper';
import { ITypeAheadOption } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PreferencesTab/CustomComponents/ControlledTypeAhead';
import { simpleGroupBy } from 'app/helpers/arrayHelpers';
import { customSwitch } from 'utils/customSwitchCase/customSwitch';
import {
  getAmnEndOfWeek,
  getAmnStartOfWeek,
  getDateValue,
  getFirstOfMonth,
  getLastOfMonth,
} from 'utils/dates/dateExtraction';
import { GetMomentOfDate } from 'utils/dates/moment';
import { Concatenate } from 'utils/string/string';
import { missingField } from 'app/constants';
import { notSent } from 'app/ComponentLibrary/Filter/helper';
import {
  ICandidateCounts,
  IFilterSpecs,
  IPlacementCounts,
  IPlacementFilterChips,
  recruiterPlacementActions,
} from '../../MyPlacementsDesk/RecruiterPlacements.redux';
import { placementStatus, placementSubStatuses } from '../../MyPlacementsDesk/utils';
import { recPlacementsGridKeys } from '../WorkdeskGrid/helper';
import { IPlacementFilter, recPlacementsFilterName } from './filterUtils';
import { FacilityCommunicationHistoryFiltersrName } from '@AMIEWEB/Facility/FacilityDetails/FacilityTabs/CommunicationHistory/Filters/FacilityCommunicationHistoryFilterUtils';
import { endOfDay } from 'date-fns';

const getCandidatesCount = dataArray => (dataArray ? Object.keys(simpleGroupBy(dataArray, 'candidateId')).length : 0);

export const getPipelineCounts = data => {
  const category = simpleGroupBy(data, 'activityType');
  const subcategory = simpleGroupBy(data, 'statusAbbr');

  const candidates: ICandidateCounts = {
    candidateCount: getCandidatesCount(data) || 0,
    inSubmission: getCandidatesCount(category[placementStatus.inSubmission]) || 0,
    waitingForClearance: getCandidatesCount(subcategory[placementSubStatuses.wfc]) || 0,
    requestFileOut: getCandidatesCount(subcategory[placementSubStatuses.rfo]) || 0,
    sent: getCandidatesCount(subcategory[placementSubStatuses.sent]) || 0,
    interviewed: getCandidatesCount(subcategory[placementSubStatuses.intrwd]) || 0,
    offer: getCandidatesCount(category[placementStatus.offer]) || 0,
    offerByFacility: getCandidatesCount(subcategory[placementSubStatuses.obf]) || 0,
    offerBookedByTraveler: getCandidatesCount(subcategory[placementSubStatuses.obbt]) || 0,
    facilityConfirms: getCandidatesCount(subcategory[placementSubStatuses.fc]) || 0,
    travelerAccepts: getCandidatesCount(subcategory[placementSubStatuses.ta]) || 0,
    bookedCategory: getCandidatesCount(category[placementStatus.booked]) || 0,
    bookedSubCategory: getCandidatesCount(subcategory[placementSubStatuses.booked]) || 0,
    bookingApproved: getCandidatesCount(subcategory[placementSubStatuses.ba]) || 0,
    waitingGoodToGo: getCandidatesCount(subcategory[placementSubStatuses.wgtg]) || 0,
    postponementWarning: getCandidatesCount(subcategory[placementSubStatuses.ppw]) || 0,
    goodToGo: getCandidatesCount(subcategory[placementSubStatuses.gtg]) || 0,
    onAssignment: getCandidatesCount(category[placementStatus.onAssignment]) || 0,
  };

  const placements: IPlacementCounts = {
    inSubmission: category[placementStatus.inSubmission]?.length || 0,
    waitingForClearance: subcategory[placementSubStatuses.wfc]?.length || 0,
    requestFileOut: subcategory[placementSubStatuses.rfo]?.length || 0,
    sent: subcategory[placementSubStatuses.sent]?.length || 0,
    interviewed: subcategory[placementSubStatuses.intrwd]?.length || 0,
    offer: category[placementStatus.offer]?.length || 0,
    offerByFacility: subcategory[placementSubStatuses.obf]?.length || 0,
    offerBookedByTraveler: subcategory[placementSubStatuses.obbt]?.length || 0,
    facilityConfirms: subcategory[placementSubStatuses.fc]?.length || 0,
    travelerAccepts: subcategory[placementSubStatuses.ta]?.length || 0,
    bookedCategory: category[placementStatus.booked]?.length || 0,
    bookedSubCategory: subcategory[placementSubStatuses.booked]?.length || 0,
    bookingApproved: subcategory[placementSubStatuses.ba]?.length || 0,
    waitingGoodToGo: subcategory[placementSubStatuses.wgtg]?.length || 0,
    postponementWarning: subcategory[placementSubStatuses.ppw]?.length || 0,
    goodToGo: subcategory[placementSubStatuses.gtg]?.length || 0,
    onAssignment: category[placementStatus.onAssignment]?.length || 0,
  };
  return { candidates, placements };
};

export const createFilterChips = (filterObj, selectedChips, t) =>
  Object.fromEntries(
    Object.entries(filterObj).map(field => {
      const key = field[0];
      const val = field[1];
      if (key === OrderMatchFlterName.orderStartDateRangeIsBlank || key === OrderMatchFlterName.orderEndDateRangeIsBlank) {
        return [key, []];
      }
      if (key === OrderMatchFlterName.startDateRange && !val && filterObj[OrderMatchFlterName.orderStartDateRangeIsBlank]) {
        return [
          key,
          [
            {
              label: `${t('search.globalSearch.order.filterNames.startDateRange')}: Blank`,
              enableDelete: true,
              value: { __orderDateBlank: 'start' },
            },
          ],
        ];
      }
      if (key === OrderMatchFlterName.orderEndDateRange && !val && filterObj[OrderMatchFlterName.orderEndDateRangeIsBlank]) {
        return [
          key,
          [
            {
              label: `${t('search.globalSearch.order.filterNames.orderEndDateRange')}: Blank`,
              enableDelete: true,
              value: { __orderDateBlank: 'end' },
            },
          ],
        ];
      }
      return [
        key,
        key === recPlacementsFilterName.placementRecruiter
          ? (val as any[])?.map(data => {
              return {
                label: `${t('home.recruiterWorkDesk.placementFilter.placementRecruiter')} : ${data?.name}`,
                isSelected: !!selectedChips?.placementRecruiter?.find(recruiter => recruiter.id === data?.id) || false,
                enableDelete: true,
                value: data,
              };
            })
          : // Temporary fix for Advanced filter chips
          [
              recPlacementsFilterName.lastApplicationDateRange.toString(),
              recPlacementsFilterName.availableToStartDateRange.toString(),
              recPlacementsFilterName.callBackDateRange.toString(),
            ].includes(key)
          ? val
            ? {
                label: `${t(`home.recruiterWorkDesk.placementFilter.${key}`)} : ${
                  (val as any).selectChoice ||
                  getDateRangeLabel(val as any) ||
                  (key.includes(recPlacementsFilterName.activeCues)
                    ? GetMomentOfDate((val as any).date).format('MM/DD/YYYY')
                    : getDateRangeLabel(val as any))
                }`,
                enableDelete: true,
              }
            : null
          : generateFieldChips(val, selectedChips ? selectedChips[key] : undefined, getPrefixLabel(t)(key), false),
      ];
    }),
  ) as unknown as IPlacementFilterChips;

const getPrefixLabel = t => key =>
  customSwitch({
    [recPlacementsFilterName.availabilityStartDateRange]: t(
      `home.recruiterWorkDesk.placementFilter.${recPlacementsFilterName.availabilityStartDateRange}`,
    ),
    [recPlacementsFilterName.startDateRange]: t(
      `home.recruiterWorkDesk.placementFilter.${recPlacementsFilterName.startDateRange}`,
    ),
    [recPlacementsFilterName.endDateRange]: t(
      `home.recruiterWorkDesk.placementFilter.${recPlacementsFilterName.endDateRange}`,
    ),
    [recPlacementsFilterName.nonContacted]: t(
      `home.recruiterWorkDesk.placementFilter.${recPlacementsFilterName.nonContacted}`,
    ),
    [recPlacementsFilterName.lastApplicationDateRange]: t(
      `home.recruiterWorkDesk.placementFilter.${recPlacementsFilterName.lastApplicationDateRange}`,
    ),
    [recPlacementsFilterName.availableToStartDateRange]: t(
      `home.recruiterWorkDesk.placementFilter.${recPlacementsFilterName.availableToStartDateRange}`,
    ),
    [recPlacementsFilterName.callBackDateRange]: t(
      `home.recruiterWorkDesk.placementFilter.${recPlacementsFilterName.callBackDateRange}`,
    ),
    [recPlacementsFilterName.activeCues]: t(
      `home.recruiterWorkDesk.placementFilter.${recPlacementsFilterName.activeCues}`,
    ),
    [recPlacementsFilterName.submission]: t(
      `home.recruiterWorkDesk.placementFilter.${recPlacementsFilterName.submission}`,
    ),
    [recPlacementsFilterName.eligibilityCleared]: t(
      `home.recruiterWorkDesk.placementFilter.${recPlacementsFilterName.eligibilityCleared}`,
    ),
    ['availableStartDate']: t('Available To Start Date'),
    ['billrate']: t('Bill Rate $'),
    [OrderMatchFlterName.guaranteedHours]: t('Guaranteed Hours'),
    [OrderMatchFlterName.expectedHours]: t('Expected hours'),
    [OrderMatchFlterName.orderAgeDateRange]: t('Order Age Date Range'),
    [OrderMatchFlterName.weeklyGrossPay]: t('Gross Pay Range ($)'),
    [OrderMatchFlterName.orderIds]: t('OID'),
    [OrderMatchFlterName.region]: t('Region'),
    [OrderMatchFlterName.shift]: t('search.globalSearch.order.filterNames.shift'),
    [OrderMatchFlterName.mspClient]: t('search.globalSearch.order.filterNames.mspClient'),
    [OrderMatchFlterName.contractAffiliates]: t('search.globalSearch.order.filterNames.contractAffiliates'),
    [OrderMatchFlterName.staffingVendor]: t('search.globalSearch.order.filterNames.staffingVendor'),
    [OrderMatchFlterName.techVendor]: t('search.globalSearch.order.filterNames.techVendor'),
    [OrderMatchFlterName.startDateRange]: t('search.globalSearch.order.filterNames.startDateRange'),
    [OrderMatchFlterName.orderEndDateRange]: t('search.globalSearch.order.filterNames.orderEndDateRange'),
    [recPlacementsFilterName.arbitrationStatus]: t('home.recruiterWorkDesk.placementFilter.arbitrationAgreement'),
    [FacilityCommunicationHistoryFiltersrName.date]: t('facility.facilityCommunicationHistory.date'),
  })(null)(key);

const RemoveAllOption = filter => {
  if (filter && typeof filter.filter === 'function') {
    return filter.filter(x => x.value !== 'All');
  }
  return [];
};

const getSubmissionFilterValue = submissionStatus => {
  if (!submissionStatus) return null;

  const { submissionError, submissionAutomated, submissionSuccessful } = submissionStatus;

  // Map submission status to filter values based on PlacementSubmissionFilter.json
  if (submissionAutomated && submissionSuccessful) {
    return 'Automated Submission - Success'; // id: 3
  } else if (submissionAutomated && submissionError) {
    return 'Automated Submission - Error'; // id: 4
  } else if (!submissionAutomated && submissionSuccessful) {
    return 'Manual Submission - Success'; // id: 1
  } else if (!submissionAutomated && submissionError) {
    return 'Manual Submission - Error'; // id: 2
  } else {
    return 'Other'; // id: 5
  }
};

const getEligibilityFilterValue = eligibilityCleared => {
  if (eligibilityCleared === true) return 'Pass';
  if (eligibilityCleared === false) return 'Fail';
  return 'Unknown'; // null, undefined, or any other value
};

export const getFilteredData = (filter, sourceData, chipSelected = {}) => {
  const data = sourceData.filter(item => {
    const isValid = [
      isDataIncluded(
        item[recPlacementsGridKeys.placementRecruiter],
        chipSelected[recPlacementsFilterName.placementRecruiter] ||
          RemoveAllOption(filter[recPlacementsFilterName.placementRecruiter]),
      ),
      isItemIncluded(
        item[recPlacementsGridKeys.candidate],
        chipSelected[recPlacementsFilterName.candidateName] ||
          RemoveAllOption(filter[recPlacementsFilterName.candidateName]),
      ),
      isSubstringIncluded(
        item[recPlacementsGridKeys.discipline],
        chipSelected[recPlacementsFilterName.discipline] || RemoveAllOption(filter[recPlacementsFilterName.discipline]),
      ),
      isSubstringIncluded(
        item[recPlacementsGridKeys.specialty],
        chipSelected[recPlacementsFilterName.specialty] || RemoveAllOption(filter[recPlacementsFilterName.specialty]),
      ),
      validateDateRange(item[recPlacementsGridKeys.endDate], filter[recPlacementsFilterName.endDateRange]),
      validateDateRange(
        item[recPlacementsGridKeys.availabilityStartDate],
        filter[recPlacementsFilterName.availabilityStartDateRange],
      ),
      validateDateRange(
        item[recPlacementsGridKeys.cueNoteAttributes]?.date,
        filter[recPlacementsFilterName.activeCues],
      ),
      (filter[recPlacementsFilterName.activeCues] && filter[recPlacementsFilterName.placementRecruiter]
        ? isIncluded(
            item[recPlacementsGridKeys.cueNoteAttributes],
            filter[recPlacementsFilterName.placementRecruiter],
          )
        : true),
      validateDateRange(item[recPlacementsGridKeys.startDate], filter[recPlacementsFilterName.startDateRange]),
      validateNonContacted(item.lastContactedOn, filter[recPlacementsFilterName.nonContacted]),
      validateDateRange(
        item[recPlacementsGridKeys.lastApplicationDate],
        filter[recPlacementsFilterName.lastApplicationDateRange],
      ),
      validateDateRange(
        item[recPlacementsGridKeys.availableToStartDate],
        filter[recPlacementsFilterName.availableToStartDateRange],
      ),
      validateDateRange(item[recPlacementsGridKeys.callBackDate], filter[recPlacementsFilterName.callBackDateRange]),
      isItemIncluded(
        item[recPlacementsGridKeys.facilityName],
        chipSelected[recPlacementsFilterName.facilityName] ||
          RemoveAllOption(filter[recPlacementsFilterName.facilityName]),
      ),
      isItemIncluded(
        item[recPlacementsGridKeys.facilityCity],
        chipSelected[recPlacementsFilterName.city] || RemoveAllOption(filter[recPlacementsFilterName.city]),
      ),
      isItemIncluded(
        item[recPlacementsGridKeys.facilityState],
        chipSelected[recPlacementsFilterName.state] || RemoveAllOption(filter[recPlacementsFilterName.state]),
      ),
      validateArbitrationStatus(item[recPlacementsGridKeys.arbitrationStatus], filter, chipSelected),
      validateSubmissionStatus(item[recPlacementsGridKeys.submissionStatus], filter, chipSelected),
      validateEligibilityStatus(item[recPlacementsGridKeys.eligibilityCleared], filter, chipSelected),
    ];

    return isValid.every(Boolean);
  });

  return {
    countObject: getPipelineCounts(data),
    flattenedData: data,
  };
};

const validateDateRange = (itemDate, filterRange) => {
  if (!filterRange) return true;
  return itemDate ? itemIsInRange(itemDate, filterRange) : false;
};

const validateNonContacted = (lastContactedOn, nonContactedFilter) => {
  if (!nonContactedFilter) return true;
  if (!lastContactedOn || lastContactedOn === missingField) return true;

  const filter = nonContactedFilter.single
    ? { ...nonContactedFilter, endDate: endOfDay(new Date()) }
    : nonContactedFilter;

  return !itemIsInRange(lastContactedOn, filter);
};

const validateArbitrationStatus = (arbitrationStatus, filter, chipSelected) => {
  const filterValue = filter[recPlacementsFilterName.arbitrationStatus];
  // If no filter is selected (null, undefined, or empty array), return true to include all
  if (!filterValue || (Array.isArray(filterValue) && filterValue.length === 0)) return true;
  
  const selectedFilters =
    chipSelected[recPlacementsFilterName.arbitrationStatus] || filterValue;
  
  // If no filters are actually selected, include all
  if (!selectedFilters || (Array.isArray(selectedFilters) && selectedFilters.length === 0)) {
    return true;
  }
  
  // Check if "Not Sent" is selected (value will be missingField '--')
  const notSentSelected = selectedFilters.some(
    filterItem => filterItem.name === notSent || filterItem.value === missingField,
  );
  
  // If item has missingField (null status), include it only if "Not Sent" is selected
  if (arbitrationStatus === missingField) {
    return notSentSelected;
  }
  
  // If item has a status, check if it matches any selected filter (excluding "Not Sent")
  const otherFilters = selectedFilters.filter(
    filterItem => filterItem.name !== notSent && filterItem.value !== missingField,
  );
  
  // If only "Not Sent" was selected and item has a status, exclude it
  if (notSentSelected && otherFilters.length === 0) {
    return false;
  }
  
  // Check if item's status matches any of the other selected filters
  // If other filters exist, check if item matches; if no other filters exist (edge case), include item
  return otherFilters.length > 0 ? isItemIncluded(arbitrationStatus, otherFilters) : true;
};

const validateSubmissionStatus = (submissionStatus, filter, chipSelected) => {
  const submissionFilter =
    chipSelected[recPlacementsFilterName.submission] || RemoveAllOption(filter[recPlacementsFilterName.submission]);

  if (!submissionFilter || submissionFilter.length === 0) return true;
  if (!submissionStatus) return false;

  const submissionFilterValue = getSubmissionFilterValue(submissionStatus);
  return submissionFilter.some(
    filterItem => filterItem.name === submissionFilterValue || filterItem.value === submissionFilterValue,
  );
};

const validateEligibilityStatus = (eligibilityCleared, filter, chipSelected) => {
  const eligibilityFilter =
    chipSelected[recPlacementsFilterName.eligibilityCleared] ||
    RemoveAllOption(filter[recPlacementsFilterName.eligibilityCleared]);

  if (!eligibilityFilter || eligibilityFilter.length === 0) return true;

  const eligibilityFilterValue = getEligibilityFilterValue(eligibilityCleared);
  return eligibilityFilter.some(
    filterItem => filterItem.name === eligibilityFilterValue || filterItem.value === eligibilityFilterValue,
  );
};

//////Advanced FilterChips//////////////
export const createAdvancedFilterChips = (fieldName, newValue, chips, t, dispatch) => {
  dispatch(
    recruiterPlacementActions.setFilterChips({
      ...chips,
      [fieldName]: {
        label: `${t(`recruiterWorkDesk.placementFilter.${fieldName}`)}: ${
          newValue.selectChoice || getDateRangeLabel(newValue)
        }`,
        enableDelete: true,
      },
    }),
  );
};

////////Last Application Date/////////
export const getLastApplicationDateRange = customSwitch({
  0: () => ({ startDate: getDateValue(0), endDate: getDateValue(0, true) }),
  1: () => ({
    startDate: getAmnStartOfWeek(),
    endDate: getAmnEndOfWeek(),
  }),
  2: () => ({ startDate: getDateValue(-30), endDate: getDateValue(0, true) }),
  3: () => ({ startDate: getDateValue(-60), endDate: getDateValue(0, true) }),
})(undefined);

///////Available To Start///////
export const getAvailableToStartDateRange = customSwitch({
  0: () => ({
    startDate: getAmnStartOfWeek(),
    endDate: getAmnEndOfWeek(),
  }),
  1: () => ({
    startDate: getFirstOfMonth(false),
    endDate: getLastOfMonth(false),
  }),
  2: () => ({
    startDate: getFirstOfMonth(true),
    endDate: getLastOfMonth(true),
  }),
})(undefined);

///////Call Back Date///////
export const getCallBackDateRange = customSwitch({
  0: () => ({ startDate: getDateValue(0), endDate: getDateValue(0, true) }),
  1: () => ({
    startDate: getAmnStartOfWeek(),
    endDate: getAmnEndOfWeek(),
  }),
  2: () => ({ startDate: getDateValue(-30), endDate: getDateValue(0, true) }),
  3: () => ({ startDate: getDateValue(-60), endDate: getDateValue(0, true) }),
})(undefined);
export const getLastContactedDate = customSwitch({
  0: getDateValue(-1),
  1: getDateValue(-2),
  2: getDateValue(-7),
  3: getDateValue(-20),
  4: getDateValue(-30),
  5: getDateValue(-60),
})(undefined);

/////////Tiles helper///////////

export const getTileCounts = data => {
  const nonContactedDate30 = getCandidatesCount(
    data.filter(item => itemIsTillDate(item.notContactedSinceDate, getLastContactedDate(4))),
  );
  const nonContactedDate20 = getCandidatesCount(
    data.filter(item => itemIsTillDate(item.notContactedSinceDate, getLastContactedDate(3))),
  );
  const callBackToday = getCandidatesCount(
    data.filter(item => itemIsInRange(item.callBackDate, getCallBackDateRange(0))),
  );
  const callBackThisWeek = getCandidatesCount(
    data.filter(item => itemIsInRange(item.callBackDate, getCallBackDateRange(1))),
  );
  const lastApplicationToday = getCandidatesCount(
    data.filter(item => itemIsInRange(item.lastApplicationDate, getLastApplicationDateRange(0))),
  );
  const lastApplicationThisWeek = getCandidatesCount(
    data.filter(item => itemIsInRange(item.lastApplicationDate, getLastApplicationDateRange(1))),
  );
  const availableToStartThisWeek = getCandidatesCount(
    data.filter(item => itemIsInRange(item.availableToStartDate, getAvailableToStartDateRange(0))),
  );
  const availableToStartNextMonth = getCandidatesCount(
    data.filter(item => itemIsInRange(item.availableToStartDate, getAvailableToStartDateRange(2))),
  );
  return {
    nonContactedDate30,
    nonContactedDate20,
    callBackToday,
    callBackThisWeek,
    lastApplicationToday,
    lastApplicationThisWeek,
    availableToStartThisWeek,
    availableToStartNextMonth,
  };
};

/////////// saga helper ////////////////
export const getRecruiterList = (recruiters, userInfo) =>
  [
    {
      id: userInfo.employeeId,
      name: Concatenate([userInfo.firstName, userInfo.lastName], ' '),
      value: userInfo.employeeId,
      object: {
        userId: userInfo.employeeId,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
      },
    },
    ...recruiters.reduce(
      (list, recruiter) =>
        recruiter.userId !== userInfo.employeeId
          ? [
              ...list,
              {
                id: recruiter.userId,
                name: Concatenate([recruiter.firstName, recruiter.lastName], ' '),
                value: recruiter.userId,
                object: recruiter,
              },
            ]
          : list,
      [],
    ),
  ] as ITypeAheadOption[];

const filterChoiceWithNewOptions = async (
  choices: ISelection[],
  newOpts: ISelection[],
  fieldName: string,
  setValue: (
    name: string,
    value: unknown,
    options?:
      | Partial<{
          shouldValidate: boolean;
          shouldDirty: boolean;
        }>
      | undefined,
  ) => void,
) => {
  const newChoices = await Promise.resolve(choices.filter(choice => newOpts.some(opt => opt.value === choice.value)));

  setValue(fieldName, newChoices, { shouldDirty: true });
  return newChoices;
};

export const filterUserChoices = async (
  filterSpecs: IFilterSpecs,
  values: IPlacementFilter,
  setValue: (
    name: string,
    value: unknown,
    options?:
      | Partial<{
          shouldValidate: boolean;
          shouldDirty: boolean;
        }>
      | undefined,
  ) => void,
) => {
  const candidateName = await filterChoiceWithNewOptions(
    values.candidateName,
    filterSpecs.candidateNameOpts,
    'candidateName',
    setValue,
  );
  const discipline = await filterChoiceWithNewOptions(
    values.discipline,
    filterSpecs.disciplineOpts,
    'discipline',
    setValue,
  );
  const specialty = await filterChoiceWithNewOptions(
    values.specialty,
    filterSpecs.specialtyOpts,
    'specialty',
    setValue,
  );
  const facilityName = await filterChoiceWithNewOptions(
    values.facilityName,
    filterSpecs.facilityNameOpts,
    'facilityName',
    setValue,
  );
  const city = await filterChoiceWithNewOptions(values.city, filterSpecs.cityOpts, 'city', setValue);
  const state = await filterChoiceWithNewOptions(values.state, filterSpecs.stateOpts, 'state', setValue);
  const arbitrationStatus = await filterChoiceWithNewOptions(
    values.arbitrationStatus || [],
    filterSpecs.arbitrationStatusOpts,
    'arbitrationStatus',
    setValue,
  );

  values.availabilityStartDateRange &&
    setValue(recPlacementsFilterName.availabilityStartDateRange, values.availabilityStartDateRange, {
      shouldDirty: true,
    });
  values.startDateRange &&
    setValue(recPlacementsFilterName.startDateRange, values.startDateRange, { shouldDirty: true });
  values.endDateRange && setValue(recPlacementsFilterName.endDateRange, values.endDateRange, { shouldDirty: true });
  values.nonContacted && setValue(recPlacementsFilterName.nonContacted, values.nonContacted, { shouldDirty: true });
  values.lastApplicationDateRange &&
    setValue(recPlacementsFilterName.lastApplicationDateRange, values.lastApplicationDateRange, { shouldDirty: true });
  values.availableToStartDateRange &&
    setValue(recPlacementsFilterName.availableToStartDateRange, values.availableToStartDateRange, {
      shouldDirty: true,
    });
  values.activeCues &&
    setValue(recPlacementsFilterName.activeCues, values.activeCues, {
      shouldDirty: true,
    });
  values.callBackDateRange &&
    setValue(recPlacementsFilterName.callBackDateRange, values.callBackDateRange, { shouldDirty: true });
  return await Promise.resolve({
    ...values,
    candidateName,
    discipline,
    specialty,
    facilityName,
    city,
    state,
    arbitrationStatus,
  });
};
